import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { FC } from 'react'

type Props = {
  open: boolean
  onCancel: () => void
  onOk: () => void
}

/**
 * カイゼン機能が ON のひな形に表を追加する際の確認ダイアログ。
 * 表を含むひな形ではカイゼン機能を使用できないため、追加してよいかを確認する。
 */
export const TableSectionAddConfirmDialog: FC<Props> = ({
  open,
  onCancel,
  onOk,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>表を追加してよろしいですか？</DialogTitle>
    <DialogContent>
      <Typography>
        表を含むひな形ではカイゼン機能を使用できません。追加すると「カイゼン機能をつける」の設定は自動的にオフになります。
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={onOk}>
        追加する
      </Button>
    </DialogActions>
  </Dialog>
)
